import { Instagram, Youtube, Mail } from "lucide-react";
import Reveal from "@/components/escape21/Reveal";

const About = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto grid max-w-5xl grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-12">
      <Reveal className="order-2 lg:order-1">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          quem é o dudu
        </span>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          criador e <span className="e21-serif text-green-400">founder</span>.
        </h2>
        <div className="mt-6 space-y-4 text-base text-white/70 sm:text-lg">
          <p>criador, atleta amador e estrategista digital.</p>
          <p>
            além do conteúdo, estou lançando o escape club, uma comunidade de alta
            performance, e o escapeflow, um app de produtividade com ia.
          </p>
          <p>
            ou seja: não sou só quem faz vídeo. construo produto de verdade,
            entendo métrica e sei o que é vender.
          </p>
          <p className="font-semibold text-white">
            é essa cabeça de founder que a tua marca leva junto na parceria.
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <a
            href="https://www.instagram.com/duducrespo_/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-sm text-white transition-colors hover:bg-white/10"
          >
            <Instagram size={18} /> instagram
          </a>
          <a
            href="https://www.tiktok.com/@duducrespo__"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-sm text-white transition-colors hover:bg-white/10"
          >
            tiktok
          </a>
          <a
            href="https://www.youtube.com/@duducrespo"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-sm text-white transition-colors hover:bg-white/10"
          >
            <Youtube size={18} /> youtube
          </a>
          <a
            href="https://duducrespo.substack.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-sm text-white transition-colors hover:bg-white/10"
          >
            <Mail size={18} /> newsletter
          </a>
        </div>
      </Reveal>

      <Reveal delay={120} className="order-1 lg:order-2">
        <div className="relative overflow-hidden rounded-2xl">
          <img
            src="/lovable-uploads/f2d82c03-7324-4443-98db-f57b5c6ab20b.png"
            alt="dudu crespo"
            className="h-auto w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
